import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import data from './data.json';

const Index = ({ children }) => {
  const [wallpaper, setWallpaper] = useState(
    data.wallpapers[Math.floor(Math.random() * data.wallpapers.length)],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * data.wallpapers.length);
      setWallpaper(data.wallpapers[randomIndex]);
    }, 1000 * 60 * 20);

    return () => clearInterval(interval);
  }, []);

  return <Wallpaper $wallpaper={wallpaper}>{children}</Wallpaper>;
};

const Wallpaper = styled.div`
  font-family: Tahoma, 'Noto Sans', sans-serif;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  background: url(${props => props.$wallpaper}) no-repeat center center fixed;
  background-size: cover;

  *:not(input):not(textarea) {
    user-select: none;
  }
`;

export default Index;
